import React from "react";

import styles from "./TableBody.module.css";

const TableBody = props => {
  return <tbody className={styles.tbody}>{props.children}</tbody>
};

export default TableBody;